export default "__VITE_ASSET__wZMnGHnV__"